import api from './axios';

export const getDailySchedule = (params) => api.get('/schedule/daily', { params });
export const getSlotDetail = (params) => api.get('/schedule/slot', { params });
export const saveSlotNote = (data) => api.put('/schedule/slot-note', data);
export const updateSlotTeachers = (data) => api.put('/schedule/slot-teachers', data);
export const enrollStudent = (data) => api.post('/schedule/enroll', data);
export const cancelEnrollment = (data) => api.post('/schedule/cancel-enrollment', data);
export const saveAttendances = (sessionId, data) => api.post(`/lesson-sessions/${sessionId}/attendances`, data);
export const saveSlotAttendances = (data) => api.put('/schedule/slot-attendances', data);
export const getSessionProjects = (sessionId) => api.get(`/lesson-sessions/${sessionId}/projects`);
export const saveSessionProjects = (sessionId, data) => api.post(`/lesson-sessions/${sessionId}/projects`, data);
export const getSessionDailyWorkNotes = (sessionId) => api.get(`/lesson-sessions/${sessionId}/daily-work-notes`);
export const getMissingProjectSessions = () => api.get('/lesson-sessions/missing-projects');
